import { render, staticRenderFns } from "./PostageCost.vue?vue&type=template&id=ba70dcd8&"
import script from "./PostageCost.vue?vue&type=script&lang=js&"
export * from "./PostageCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports